module.exports = __webpack_public_path__ + "img/edit.67a6f7ef.svg";